import { Stack, styled } from '@mui/material';

export const FilterContentContainer = styled(Stack)`
  padding: 8px 0 8px 4px;
  max-height: 265px;
  overflow: auto;
`;
